import { render } from "./settings.vue?vue&type=template&id=1c906393&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=1c906393&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c906393"]])

export default __exports__